<script>
import VueSimpleSuggest from 'vue-simple-suggest'

export default {
    extends: VueSimpleSuggest,
    props: {
        controls: {
            type: Object,
            default: () => ({  // Overridden and disabled to prevent users from selecting options with the keyboard.
                selectionUp: [],
                selectionDown: [],
                select: [],
                showList: [],
                hideList: [],
                autocomplete: [],
            }),
        }
    },
    methods: {
        // Replace setText, since we are using event to add a tag anyways
        // TODO: Find a better long term solution to this
        setText: function() {
        },
    }
}
</script>
